"use client";

import { useTranslations } from "next-intl";
import type { ProductForClient, ProductVariantForClient } from "@/lib/shared/types/interfaces";
import { translateProductVariantLabel } from "@/lib/shared/utils/productVariantLabel";
import { cn, HStack, Text, VStack } from "@/ui";

interface TryOnVariantSelectorProps {
  product: ProductForClient;
  selectedVariant: ProductVariantForClient;
  onVariantChange: (variant: ProductVariantForClient) => void;
}

export function TryOnVariantSelector(props: TryOnVariantSelectorProps) {
  const { product, selectedVariant, onVariantChange } = props;
  const t = useTranslations("virtual_try_on");
  const productDetailsT = useTranslations("product_details");

  if (product.variants.length <= 1) {
    return null;
  }

  return (
    <VStack className="gap-2">
      <Text className="text-sm font-medium">{t("select_variant")}</Text>
      <HStack className="flex-wrap gap-2">
        {product.variants.map((variant) => {
          const active = variant.variant.id === selectedVariant.variant.id;
          return (
            <button
              key={variant.variant.id}
              type="button"
              className={cn(
                "rounded-md border px-3 py-1.5 text-xs transition-colors",
                active
                  ? "border-primary bg-primary/10 text-foreground"
                  : "border-border text-muted-foreground hover:border-primary/50",
              )}
              onClick={() => onVariantChange(variant)}
              aria-pressed={active}
            >
              {translateProductVariantLabel(productDetailsT, variant.variant.variant)}
            </button>
          );
        })}
      </HStack>
    </VStack>
  );
}
